// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    adyen: {
        environment: 'live',
        originKey:
            'pub.v2.4115837907343891.aHR0cHM6Ly9hcHAuZ29waG90by5wcm8.QpJdzm76EiTF0VeBpwISnCwFVSCUsvZZtZY74auKV8g',
    },
    fingerprintjs: {
        apiKey: 'FvrgjfnYdJyivNfCzdjD',
    },
    http: {
        // baseUri: 'https://api-dashboard.gophoto.pro/api',
        baseUri: 'https://api-eu-v2.gophoto.pro',
        globalApiUri: 'https://api.gophoto.app',
        globalCMSUri: 'https://cms.gophoto.app',
        // baseUri: 'http://localhost:4000/api',
        authorization: {
            headerName: 'Authorization',
            tokenPrefix: 'Bearer',
        },
    },
    linkpage: {
        rootDomain: 'gophoto.pro',
    },
    logoutUrl: 'https://cms.gophoto.app/',
    production: true,
    recaptcha: {
        siteKey: '6LdNDuAUAAAAAKgz4n-wlWB4VTF6aADrTkKu7u7w',
    },
    regionSwitches: [{ label: 'Switch to US region', url: 'https://cms.us1.gophoto.app' }],
    serverTimezone: 'UTC',
};
